import { render } from "./RemoveTrustedDevice.vue?vue&type=template&id=72fd61b4&scoped=true"
import script from "./RemoveTrustedDevice.vue?vue&type=script&lang=js"
export * from "./RemoveTrustedDevice.vue?vue&type=script&lang=js"

import "./RemoveTrustedDevice.vue?vue&type=style&index=0&id=72fd61b4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fd61b4"]])

export default __exports__